import { render, staticRenderFns } from "./WorkParent.vue?vue&type=template&id=545c7060&scoped=true&"
import script from "./WorkParent.vue?vue&type=script&lang=js&"
export * from "./WorkParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545c7060",
  null
  
)

export default component.exports